import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { Injectable } from "@angular/core";
import { APIs } from 'src/app/_Core/_Constants/api.constant';
import { AppConstant } from 'src/app/_Core/_Constants/app.constant';
import { NotificationModel } from 'src/app/_Core/_Models/Notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  allNotifications = new BehaviorSubject<NotificationModel[]>([])
  constructor(private apiSrv: ApiService) { }

  getAllNotifications(): Observable<any> {
    return this.apiSrv.get(APIs.getAllNotifications + "/" + localStorage.getItem("tenantId")).pipe(map(response => {
      this.setAllNotifications(response.list);
      return response;
    }))
  }

  updateAllNotifications(payload): Observable<any> {
    return this.apiSrv.post(APIs.updateNotification, payload).pipe(map(response => {
      return response;
    }))
  }

  clearNotification(payload): Observable<any> {
    return this.apiSrv.post(APIs.clearNotification, payload).pipe(map(response => {
      return response;
    }))
  }

  setAllNotifications(notifications) {
    this.allNotifications.next(notifications);
  }

  getSavedNotifications() {
    return this.allNotifications.asObservable();
  }
}
